/*eslint-disable */
const $ = window.jQuery = require('jquery');

import commonSocketRef from "@/videoNotificationSocket";
import loader from '@/components/common/component-small-loader';
import {
  mapGetters,
} from 'vuex';
import toast from '@/services/toast';

export default {
  name: 'remarks',
  components: {
    loader
  },
  props: ['remarksOfPateintId'],
  data () {
    return {
      listedOfRemarksPatient:null,
      listedOfRemarksPatientResults:[],
      remarksOfPatientFirstStep:true,
      remarksOfPatientSecondStep:false,
      remarksOfPatientThirdStep:false,
      remarksOfPatientFourStep:false,
      createRemarksTitle:'',
      createRemarksData:'',
      updateRemarksDataId:'',
      updateRemarksTitle:'',
      updateRemarksData:'',
      removePopupState:false
    }
  },
  computed: {
  },
  mounted () {
    this.getRemarksListedOfPatientMethod(this.remarksOfPateintId)
  },
  methods: {
    getRemarksListedOfPatientMethod(id){
      if(!id) return;
      this.$store.dispatch('getRemarksListOfPatientMethod', {id:id}).then((res)=>{
        this.listedOfRemarksPatient =  res.data.data
        this.listedOfRemarksPatientResults = res.data.data.results
      })
    },
    createdRemarksDataSectionEnabled(){
      this.remarksOfPatientFirstStep = false
      this.remarksOfPatientSecondStep = true
    },
    goToFistStepFromSecond(){
      this.remarksOfPatientFirstStep = true
      this.remarksOfPatientSecondStep = false
    },
    goToFistStepFromThird(){
      this.remarksOfPatientFirstStep = true
      this.remarksOfPatientThirdStep = false
    },
    savedRemarksDataMethod(){
      if(this.createRemarksTitle.length > 0){
        let data = {
          data:this.createRemarksData,
          title:this.createRemarksTitle,
          patient_id:this.remarksOfPateintId
        }
        this.$store.dispatch('createRemarksOfPatientMethod', data).then((res)=>{
          let notificationPayload = { 
            type:'patient_remark',
            data_id:res.data.data.id,
            message:'patient remark has benn created'
          }
          this.$store.dispatch('postNotificationFunc', notificationPayload)
          this.getRemarksListedOfPatientMethod(this.remarksOfPateintId)
          this.createRemarksData = ''
          this.createRemarksTitle = ''
          this.goToFistStepFromSecond()
        }).catch((err)=>{
        })
        commonSocketRef.emit({
          message: `Remark Data`,
          type: "patient_remark",
          patient_id:this.remarksOfPateintId
        });
      }else{
        this.goToFistStepFromSecond()
      }
    },
    updateRemarksDataMethod(data){
      this.updateRemarksDataId = data.id
      this.updateRemarksTitle = data.title
      this.updateRemarksData = data.data
      this.remarksOfPatientFirstStep = false
      this.remarksOfPatientThirdStep = true
    },
    updatedPatientRemarksDataMethod(){
      let data = {
        data:this.updateRemarksData,
        title:this.updateRemarksTitle
      }
      this.$store.dispatch('updateRemarksDataOfPatientMethod',{data:{data:data,id:this.updateRemarksDataId }}).then((res)=>{
        let notificationPayload = { 
          type:'patient_remark_updated',
          data_id:this.remarksOfPateintId,
          message:'patient remark has benn updated'
        }
        this.$store.dispatch('postNotificationFunc', notificationPayload)
        this.getRemarksListedOfPatientMethod(this.remarksOfPateintId)
      }).catch((err)=>{})
      commonSocketRef.emit({
        message: `Update Remark Data`,
        type: "patient_remark",
        patient_id:this.remarksOfPateintId,
      });
    },
    removeRemarksOfPatientPopupOpenMethod(){
      this.removePopupState =  true
      document.body.classList.add('body_right_scroll_remove')
    },
    removeRemarksOfPatientPopupClosedMethod(){
      this.removePopupState =  false
      document.body.classList.remove('body_right_scroll_remove')
    },
    removeRemarksFromListedMethod(){
      this.$store.dispatch('removeRemarksOfPatientMethod', {id:this.updateRemarksDataId}).then((res)=>{
        let notificationPayload = { 
          type:'patient_remark_removed',
          data_id:this.updateRemarksDataId,
          message:'patient remark has benn removed'
        }
        this.$store.dispatch('postNotificationFunc', notificationPayload)
        toast.success(res.data.msg);
        this.goToFistStepFromThird()
        this.getRemarksListedOfPatientMethod(this.remarksOfPateintId)
        this.removeRemarksOfPatientPopupClosedMethod()
        commonSocketRef.emit({
          message: `Remove Remark Data`,
          type: "patient_remark",
          patient_id:this.remarksOfPateintId
        });
      }).catch((err)=>{
        toast.error(err.data.msg);
      })
    },
  },
  watch:{
    remarksOfPateintId(new_val, old_val){
      this.getRemarksListedOfPatientMethod(new_val)
    }
  }
}